const env = {
  development: {
    //在 vue.config.js 设置跨域
    API_ORIGIN: ' /proxy',
    IMAGE_ORIGIN: 'https://xwjd-test.oss-cn-shanghai.aliyuncs.com',
  },
  test: {
    API_ORIGIN: '/api',
    IMAGE_ORIGIN: 'https://xwjd-test.oss-cn-shanghai.aliyuncs.com',
  },
  canary: {
    API_ORIGIN: 'https://top.canary.xw-jd.com/api',
    IMAGE_ORIGIN: 'https://img.xw-jd.com'
  },
  production: {
    API_ORIGIN: 'https://top.xw-jd.com/api',
    IMAGE_ORIGIN: 'https://img.xw-jd.com'
  }
}
export default env[process.env.VUE_APP_BUILD_ENV]
